<template>
  <div
    data-qa="lpu_loyalty_program_plate"
    class="d-flex align-center gc-4 py-2 px-3 rounded special--text bg-special cursor-pointer"
    @click="emit('click')"
  >
    <span class="ui-icon-four-pointed-star-fill ui-icon_type_40 bg-gray-0--text special flex-shrink-0" />
    <span class="text-body-1">{{ t('Программа лояльности клиники', options) }}</span>
    <span class="ui-icon-arrow-right ml-auto" />
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

type Emits = {
  (_event: 'click'): void
}

const emit = defineEmits<Emits>()
</script>
